import { useParams } from 'react-router-dom'
import { useGetSubnets } from 'services/subnetApiService/useSubnetApiService'
import Cortext from './Subnets/Cortext'
import MainComponent from 'pages/MainComponent'
import OpenKaito from './Subnets/OpenKaito/OpenKaito'
import Datura from './Subnets/Datura'
import TextPrompting from './Subnets/TextPrompting'
import Vision from './Subnets/Vision'
import TensorAlchemy from './Subnets/TensorAlchemy'
import BitAgent from './Subnets/BitAgent'
import NicheImage from './Subnets/NicheImage'

const Playground = () => {
    const { id } = useParams()

    const { data: subnets } = useGetSubnets()

    const currentSubnet = subnets?.find(subnet => subnet.id === id)

    const comingSoonComponent = <MainComponent value={'Coming Soon'} />

    const subnetPlaygroundList = [
        { name: 'Text Prompting', playground: <TextPrompting /> },
        { name: 'Omron', playground: comingSoonComponent },
        { name: 'Targon', playground: comingSoonComponent },
        { name: 'Open Kaito', playground: <OpenKaito /> },
        { name: 'Subvortex', playground: comingSoonComponent },
        { name: 'Sturdy', playground: comingSoonComponent },
        { name: 'Data Universe', playground: comingSoonComponent },
        { name: 'LLM Defender', playground: comingSoonComponent },
        { name: 'Bittensor Blockchain', playground: comingSoonComponent },
        { name: 'BitAds', playground: comingSoonComponent },
        { name: 'Cortex.t', playground: <Cortext /> },
        { name: 'Vision', playground: <Vision /> },
        { name: 'BitAgent', playground: <BitAgent /> },
        { name: 'FileTAO', playground: comingSoonComponent },
        { name: 'Datura SmartScrape', playground: <Datura /> },
        { name: 'NicheImage', playground: <NicheImage /> },
        { name: 'Omega Labs', playground: comingSoonComponent },
        { name: 'Tensor Alchemy', playground: <TensorAlchemy /> },
        { name: 'Compute', playground: comingSoonComponent },
        { name: 'Foundry S&P', playground: comingSoonComponent },
        { name: 'Fractal', playground: comingSoonComponent },
        { name: 'WomboAI', playground: comingSoonComponent },
        { name: 'LLM Detection', playground: comingSoonComponent },
    ]

    if (!currentSubnet) return null

    return (
        <>
            {subnetPlaygroundList.map(playground => {
                const normalizedSubnetName = currentSubnet?.name?.replace(/\s+/g, '').toLowerCase()
                const normalizedPlaygroundName = playground.name.replace(/\s+/g, '').toLowerCase()

                if (normalizedSubnetName?.includes(normalizedPlaygroundName)) {
                    return playground.playground
                }

                return null
            })}
        </>
    )
}

export default Playground
